(function () {
  if (window.__TOW_SALES_BLOCK_INIT__) return;
  window.__TOW_SALES_BLOCK_INIT__ = true;

  var cfg = window.TOW_SALES_BLOCK || {};
  if (cfg.salesEnabled !== false) return;

  var home = cfg.homeUrl || "/";
  var message =
    cfg.message ||
    "Gli acquisti online non sono disponibili in questo momento.";

  document.documentElement.className +=
    (document.documentElement.className ? " " : "") + "tow-sales-off";
  document.body.className +=
    (document.body.className ? " " : "") + "tow-sales-off";

  function showBanner() {
    if (document.querySelector(".tow-sales-banner")) return;
    var el = document.createElement("div");
    el.className = "tow-sales-banner";
    el.setAttribute("role", "status");
    el.textContent = message;
    document.body.insertBefore(el, document.body.firstChild);
  }

  function isCartOrCheckoutPath(path) {
    return (
      /\/cart(\/|$|\?)/.test(path) ||
      /\/checkouts?\b/.test(path) ||
      /\/checkout(\/|$|\?)/.test(path)
    );
  }

  function blockNavigation() {
    var path = location.pathname + location.search;
    if (isCartOrCheckoutPath(path)) {
      location.replace(home);
    }
  }

  function isPurchaseControl(el) {
    if (!el || el.nodeType !== 1) return false;
    var tag = el.tagName;
    if (tag !== "A" && tag !== "BUTTON" && tag !== "INPUT") return false;

    var text = (el.textContent || el.value || "").toLowerCase();
    var href = (el.getAttribute("href") || "").toLowerCase();
    var name = (el.getAttribute("name") || "").toLowerCase();
    var form = el.closest ? el.closest("form") : null;
    var action = ((form && form.getAttribute("action")) || "").toLowerCase();

    if (name === "add" || name === "checkout") return true;
    if (href.indexOf("/cart") !== -1 || href.indexOf("/checkout") !== -1)
      return true;
    if (
      action.indexOf("/cart/add") !== -1 ||
      action.indexOf("/cart/update") !== -1
    )
      return true;
    if (
      /riordina|reorder|buy again|acquista di nuovo|ordina di nuovo/.test(text)
    )
      return true;
    if (href.indexOf("/buy") !== -1 && href.indexOf("/orders/") !== -1)
      return true;
    return false;
  }

  function onClickCapture(event) {
    var target = event.target;
    while (target && target !== document) {
      if (
        target.tagName === "A" ||
        target.tagName === "BUTTON" ||
        target.tagName === "INPUT"
      )
        break;
      target = target.parentNode;
    }
    if (!isPurchaseControl(target)) return;
    event.preventDefault();
    event.stopPropagation();
    alert(message);
  }

  function onSubmitCapture(event) {
    var form = event.target;
    if (!form || form.tagName !== "FORM") return;
    var action = (form.getAttribute("action") || "").toLowerCase();
    var hasPurchase =
      form.querySelector('[name="add"],[name="checkout"]') !== null;
    if (
      action.indexOf("/cart") !== -1 ||
      action.indexOf("/checkout") !== -1 ||
      hasPurchase
    ) {
      event.preventDefault();
      event.stopPropagation();
      alert(message);
    }
  }

  function patchFetch() {
    if (!window.fetch) return;
    var original = window.fetch.bind(window);
    window.fetch = function (input, init) {
      var url =
        typeof input === "string"
          ? input
          : input && input.url
            ? input.url
            : "";
      if (/\/cart\/(add|update|change|clear)/i.test(url)) {
        return Promise.reject(new Error(message));
      }
      return original(input, init);
    };
  }

  function patchXHR() {
    var open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__towUrl = String(url || "");
      return open.apply(this, arguments);
    };
    var send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      if (/\/cart\/(add|update|change|clear)/i.test(this.__towUrl || "")) {
        this.abort();
        alert(message);
        return;
      }
      return send.apply(this, arguments);
    };
  }

  showBanner();
  blockNavigation();
  document.addEventListener("click", onClickCapture, true);
  document.addEventListener("submit", onSubmitCapture, true);
  patchFetch();
  patchXHR();
})();
